export default {
  'page-title': 'Return Merchandize Authorization (RMA) System - Creative Labs  ',
  'page-desc': 'Check the status of your return request with your RMA number. ',

  'page-title-return': 'Return Merchandize Authorization (RMA) System - Creative Labs  ',
  'page-desc-return': 'Check the status of your return request with your RMA number. ',

  'page-title-replacement': 'Received Wrong / Damaged Items - Creative Labs',
  'page-desc-replacement': 'Received a wrong or damaged item? Let us know, and we will get this fixed for you.',

  'page-title-checkstatus': 'Return Merchandize Authorization (RMA) System - Creative Labs  ',
  'page-desc-checkstatus': 'Check the status of your return request with your RMA number',

  'mode-of-contact': 'Mode Of Contact',
  'your-details': 'Your Details',
  'rma-request': 'RMA Request',
  'first-name': 'First Name',
  'last-name': 'Last Name',
  'enter-first-name': 'Please enter your first name.',
  'enter-last-name': 'Please enter your last name.',
  'email-address': 'Email Address',
  'enter-email': 'Please enter your email address.',
  'enter-valid-email': 'Please enter a valid email address.',
  'enter-pid': 'Please enter your personal ID',
  'super-x-fi': 'Super X-Fi',
  'products': 'Products',
  'sale': 'Sale',
  'help': 'Help',
  'sign-in': 'Sign In',
  'account': 'Account',
  'loading-page': 'LOADING',
  'orders': 'Orders',
  'membership-program': 'Membership Program',
  'account-profile': 'Account Profile',
  'contact-us': 'Contact Us',
  'sign-out': 'Sign Out',
  'recent-orders': 'Recent Orders',
  'view-all-orders': 'View All Orders',
  'email_registered': {
    'text1': '{email} has already been registered. ',
    'link': 'Sign in',
    'text2': ' to retrieve your order history.'
  },
  'country-region': 'Country/Region',
  'select-country': 'Please select country.',
  'preferred-language': 'Preferred language of reply',
  'select-language': 'Please select language.',
  'next': 'Next',
  'encountered-error': 'We encountered an error. Please try again.',
  'your-enquiry': 'Your Enquiry',
  'nature-enquiry': 'Nature of Enquiry',
  'order-number': 'Order Number',
  'order-id': 'Amazon Order ID',
  'for-amazon-order': 'For orders placed through Amazon',
  'enter-order-number': 'Please enter your order number.',
  'rma-number': 'RMA Number',
  'enter-rma-number': 'Please enter your RMA number.',
  'purchase_creative_com': {
    'text': 'If your defective product was purchased from Creative.com ',
    'link': 'request a replacement here.'
  },
  'not-purchase-creative-com': '<p>If you did not purchase directly from Creative.com, please approach your retailer directly for return requests. </p><p><a href="https://creative.com/g/help/warranty-returns" target="_blank">Click here for warranty and return information.</a></p>',
  'not-purchase-creative-com-retailer-replacement': 'If you did not purchase directly from Creative.com, please approach your retailer directly for replacement requests.',
  'not_purchase_creative_com_2': {
    'text': 'If your defective product was not purchased directly from Creative.com, ',
    'link': 'request a replacement here.'
  },
  'order-not-found': 'This order number does not belong to this email address. Please try again.',
  'rma-not-found': 'The RMA number you have entered is not found in our records. Please enter a valid RMA number.',
  'previous-order': 'Previous Order',
  'next-order': 'Next Order',
  'add-your-product': 'Add Your Product',
  'search-by-name': 'Search by product name',
  'select-product': 'Please select at least 1 product.',
  'upload-proof-update-date': {
    'text1': 'Please provide your proof of purchase and the date of purchase. <br/>If you do not have your proof of purchase, please ',
    'link': 'contact us',
    'text2': ' here.'
  },
  'return-product': 'Return Product',
  'return-products': 'Return Product(s)',
  'replace-defective-product': 'Replace Defective Product',
  'check-rma-status': 'Check RMA Status',
  'service-request': 'Service Request(s) Available',
  'select-one-service': 'Please select one service request. If you have more than 1 service request for the same order, please raise a different service request for each issue.',
  'select-one-servcie-2': 'Please select one service request.',
  'refund-products': 'Refund Product(s)',
  'qualifies-refund': 'Only {refundNotAvailable} qualifies for a refund under Satisfaction Guarantee. <br />Please edit your products before proceeding.',
  'replace-products': 'Replace Defective Product(s)',
  'qualifies-replace': 'Only {repairNotAvailable} qualifies for a replacement. <br />Please edit your products before proceeding. ',
  'contact-us-assistance': 'Contact Us for Assistance',
  'return-information': 'Return Information',
  'replacement-information': 'Replacement Information',
  'fill-in-all': 'Please fill in all fields in this section.',
  'message': 'Message',
  'enter-message': 'Please enter your message.',
  'submit': 'Submit',
  'submission-successful': 'Your submission has been submitted.',
  'contact-us-thank-you': 'We will get back to you in 2 business days.',
  'back-to-home': 'Back to Home',
  'confirmation': 'Confirmation',
  'rma-confirmation': 'RMA Confirmation',
  'refresh-page': 'Refresh',
  'loading': 'Loading...',
  'select': 'Select Address',
  'selected': 'Selected',
  'update': 'Edit Address',
  'address': 'Address',
  'new-address': 'New Address',
  'edit': 'Edit',
  'update-address': 'Update Address',
  'cancel': 'Cancel',
  'back': 'Back',
  'select-your-products': 'Select Your Product(s)',
  'serial-number': 'Serial Number',
  'returns-eligibility': 'Returns Eligibility',
  'warranty': 'Warranty',
  'proof-purchase': 'Proof of Purchase',
  'purchase-date': 'Purchase Date',
  'select-date': 'Select date',
  'how-find-serial-num': 'How to find your serial number?',
  'yes': 'Yes',
  'no': 'No',
  'choose-file': 'Choose File',
  'upload-supporting-file': 'Please upload supporting images(s)',
  'remove': 'Remove',
  'warranty-days-left': '{warrantyDaysRemain} day(s) left',
  'out-warranty': 'Out of Warranty',
  'enter-serial': 'Enter serial number',
  'enter-serial-number': 'Please enter a valid serial number.',
  'serial-not-valid': 'Please enter a valid serial number.',
  'serial-num-submitted': 'Serial number has been submitted previously, please enter a valid serial number.',
  'file-formats-allowed': 'File formats allowed: JPG, PNG, ZIP. Maximum file size: 4MB.',
  'thank-you-rma-submit': 'Thank you for your RMA submission. ',
  'provide-rma-number': 'Please provide your RMA number to our Customer Service Team if you\'re contacting us regarding this RMA.',
  'retrieve_rma_status': {
    'text': 'You may also retrieve your RMA status or make changes to your RMA by registering for a ',
    'link': 'Creative Store account'
  },
  'product-details': 'Product Details',
  'product': 'Product',
  'rma-details': 'RMA Details',
  'service-request2': 'Service Request',
  'refund': 'Refund',
  'replacement': 'Replacement',
  'rma-status': 'RMA Status',
  'expires-date': 'Expires {date}',
  'refund-estimated-cost': 'Note: The refund amount is currently an estimation, and may be subjected to further change.',
  'service-fee': 'Service Fee',
  'service-fee-text': 'A service fee may be levied if your returned product shows signs of accidental damage or abuse. You will be contacted via email if this is applicable.',
  'product-is-defective': 'Product is defective',
  'repair-status-list': [
    {
      'status': 'RMA Request Received',
      'desc': '<p>Your RMA request is currently being processed.<br /><i>(Usually takes 1 - 2 business days)</i></p>'
    },
    {
      status: 'RMA Approved',
      desc: `<p>Please send your product back to us. <br /><i>(Usually takes 1 - 2 business days)</i></p>
              <span style="text-decoration:underline">Return Instructions</span>

              <div class="return-instruction">
                  <div id="display_uk" style="display:{display_uk}">
                    Please refer to the email (Subject: Your Creative Labs return request has been approved) for the return instructions.
                    You can generate the return shipping label through the following link, and enter the information as listed:
                    <p style="margin:10px auto">
                      URL: <a href="{courierLabelLink}" target="_blank">https://www.royalmail.com/track-my-return/create/4205</a>   <br />
                      Return Merchandise Authorization (RMA) Number: <span style='font-weight:500'>{orderNumber}</span>
                    </p>
                    <p>
                      Do note that once the shipping label has been used, it will no longer be usable.
                    </p>
                  </div>

                  <div id="display_eu" style="display:{display_eu}">
                    Please refer to the email (Subject: Your Creative Labs return request has been approved) for the return instructions.
                    You can generate the return shipping label through the following link, and enter the information as listed:
                    <p style="margin:10px auto">
                      URL: <a href="{courierLabelLink}" target="_blank">{courierLabelLink}</a> <br>
                      Customer Ref #1:  <span style='font-weight:500'>{orderNumber}</span> <br>
                    </p>
                    <p>
                      Do note that once the shipping label has been used, it will no longer be usable.
                    </p>
                  </div>

                  <div id="display_others" style="display:{display_others}">
                    Please refer to the email (Subject: Your Creative Labs return request has been approved) for the return instructions.
                    <p id="display_shippingLabel1" style="margin:10px auto;{display_shippingLabel}">
                        Your shipping label must be downloaded within 90 days.
                        Once the label is accessed for the first time, it must be downloaded or printed within 5 days, after which it will no longer be accessible.<br>
                        <a href="{courierLabelLink}" target="_blank" style="text-decoration:underline">Shipping Label</a>
                    </p>
                    <p id="display_shippingLabel2" style="margin:10px auto;{display_shippingLabel}">
                      Do note that once the shipping label has been used, it will no longer be usable.
                    </p>

                  </div>
              </div>`,

      desc2: `<p>Please send your product back to us. <br /><i>(Usually takes 1 - 2 business days)</i></p>
              <span style="font-weight: 500;">Return Instructions</span>
              <div class="return-instruction">
                Please refer to the email (Subject: Your Creative Labs return request has been approved) for the return instructions.

                <p style="margin:10px auto;{display}">
                Your shipping label must be downloaded within 90 days.
                Once the label is accessed for the first time, it must be downloaded or printed within 5 days, after which it will no longer be accessible.<br>
                <a href="{shippingLabelLink}" target="_blank" style="text-decoration:underline">Shipping Label</a></p>
              </div>`
    },
    {
      status: 'Product Received',
      desc: '<p>We are verifying your returned product.<br /><i>(Usually takes 1 - 2 business days)</i></p>',
    },
    {
      status: 'Preparing Replacement',
      desc: '<p>We are checking on the stock availability of your replacement unit.<br /><i>(Usually takes 1 - 2 business days)</i></p>',
    },
    {
      status: 'Preparing Shipment',
      desc: '<p>We are preparing your replacement unit for shipment.<br /><i>(Usually takes 1 - 2 business days)</i></p>',
    },
    {
      status: 'Replacement Shipped',
      desc: '<p>Your replacement unit has been shipped.  <br />   </p>',
    }
  ],
  'refund-status-list-backup-v1': [
    {
      status: 'Replacement Shipped',
      desc: '<p>Your replacement unit has been shipped.  <br /> {courierInfomation} <br />{trackingNumber}<br />{trackingURL}  </p>',
    },
    {
      'status': 'RMA Request Received',
      'desc': '<p>Your RMA request is currently being processed.<br /><i>(Usually takes 1 - 2 business days)</i></p>'
    },
    {
      status: 'RMA Approved',
      desc: `<p>Please send your product back to us. <br /><i>(Usually takes 1 - 2 business days)</i></p>
              <span style="font-weight: 500;">Return Instructions</span>
              <div class="return-instruction">
                Please refer to the email (Subject: Your Creative Labs return request has been approved) for the return instructions.

                <p style="margin:10px auto;{display}">
                Your shipping label must be downloaded within 90 days.
                Once the label is accessed for the first time, it must be downloaded or printed within 5 days, after which it will no longer be accessible.<br>
                <a href="{shippingLabelLink}" target="_blank" style="text-decoration:underline">Shipping Label</a></p>
              </div>`
    },
    {
      status: "Product Received",
      desc: "<p>We are verifying your returned product.<br /><i>(Usually takes 1 - 2 business days)</i></p>",
    },
    {
      status: "Processing Refund",
      desc: "<p>Your product has been verified, and we're processing your refund<span style='{showAmount}'> of <strong>{RefundAmtActual}</strong></span>.<br /><i>(Usually takes 3 - 5 business days)</i></p>",
    },
    {
      status: "Refund Completed",
      desc: "<p>We have completed the refund back to your original method of payment. This may take up to 30 days for your bank to process the request. Please contact your bank for further enquiries.</p><p><i>(May take up to 30 days for your bank to process the receiving of the refund)</i></p>",
    }
  ],
  'refund-status-list': [
    {
      'status': 'RMA Request Received',
      'desc': '<p>Your RMA request is currently being processed.<br /><i>(Usually takes 1 - 2 business days)</i></p>'
    },
    {
      status: 'RMA Approved',
      desc: `<p>Please send your product back to us. <br /><i>(Usually takes 1 - 2 business days)</i></p>
              <span style="text-decoration:underline">Return Instructions</span>

              <div class="return-instruction">
                  <div id="display_uk" style="display:{display_uk}">
                    Please refer to the email (Subject: Your Creative Labs return request has been approved) for the return instructions.
                    You can generate the return shipping label through the following link, and enter the information as listed:
                    <p style="margin:10px auto">
                      URL: <a href="{courierLabelLink}" target="_blank">https://www.royalmail.com/track-my-return/create/4205</a>   <br />
                      Return Merchandise Authorization (RMA) Number: <span style='font-weight:500'>{orderNumber}</span>
                    </p>
                    <p>
                      Do note that once the shipping label has been used, it will no longer be usable.
                    </p>
                  </div>

                  <div id="display_eu" style="display:{display_eu}">
                    Please refer to the email (Subject: Your Creative Labs return request has been approved) for the return instructions.
                    You can generate the return shipping label through the following link, and enter the information as listed:
                    <p style="margin:10px auto">
                      URL: <a href="{courierLabelLink}" target="_blank">{courierLabelLink}</a> <br>
                      Customer Ref #1:  <span style='font-weight:500'>{orderNumber}</span> <br>
                    </p>
                    <p>
                      Do note that once the shipping label has been used, it will no longer be usable.
                    </p>
                  </div>

                  <div id="display_others" style="display:{display_others}">
                    Please refer to the email (Subject: Your Creative Labs return request has been approved) for the return instructions.
                    <p id="display_shippingLabel1" style="margin:10px auto;{display_shippingLabel}">
                        Your shipping label must be downloaded within 90 days.
                        Once the label is accessed for the first time, it must be downloaded or printed within 5 days, after which it will no longer be accessible.<br>
                        <a href="{courierLabelLink}" target="_blank" style="text-decoration:underline">Shipping Label</a>
                    </p>
                    <p id="display_shippingLabel2" style="margin:10px auto;{display_shippingLabel}">
                      Do note that once the shipping label has been used, it will no longer be usable.
                    </p>

                  </div>
              </div>`

    },
    {
      status: "Product Received",
      desc: "<p>We are verifying your returned product.<br /><i>(Usually takes 1 - 2 business days)</i></p>",
    },
    {
      status: "Processing Refund",
      desc: "<p>Your product has been verified, and we're processing your refund<span style='{showAmount}'> of <strong>{RefundAmtActual}</strong></span>.<br /><i>(Usually takes 3 - 5 business days)</i></p>",
    },
    {
      status: "Refund Completed",
      desc: "<p>We have completed the refund back to your original method of payment. This may take up to 30 days for your bank to process the request. Please contact your bank for further enquiries.</p><p><i>(May take up to 30 days for your bank to process the receiving of the refund)</i></p>",
    }
  ],
  'what-are-reason': 'What is the reason for your return?',
  'which-part-defective': 'Which part of your product is defective?',
  'please-select-one': 'Please select one',
  'cosmetic-damages': 'Are there any physical / cosmetic damages to the product?',
  'attach-photo': 'Attach photo of the damages:',
  'comments': 'Comments',
  'enter-comments': 'Please enter a detailed description of your enquiry.',
  'rma-exists': 'A RMA request has been submitted for this product.',
  'rma-created': 'A RMA request already exists for this product, and can\'t be created again.',
  'rma-cancelled': 'Your RMA request has been cancelled. If you have any questions regarding your RMA request cancellation, please contact us.',
  'selected-maximum': 'You have selected the maximum quantity allowed.',
  'shipping-information': 'Shipping Information',
  'shipping-address': 'Shipping Address',
  'select-shipping-address': 'Please select shipping address.',
  'replace-sent-address': 'Your replacement will be sent to the following shipping address. ',
  'product-purchased-from': 'Product Purchased From',
  'creative-store': 'Creative Store',
  'all-other-retailers': 'All Other Retailers',
  'product-not-received': 'Not Received',
  'product-cancelled': 'Cancelled',
  'rma-closed': 'Closed',
  'select-mode-of-contact': 'Please select your mode of contacting us.',
  'email-us': 'Email Us',
  'your-order': 'Your Order',
  'refund-amount': 'Refund Amount',
  'shipping-charge': 'Shipping Charge',
  'store-credit': 'Store Credit',
  'tax': 'Tax',
  'deliver-unable-info': 'We are unable to deliver to P.O. boxes, hotels, motels, and the following overseas territories. <a href="/help/delivery#what-are-the-overseas-territories-that-you-don-39-t-deliver-to" target="_blank">Learn more</a>.',
  'creative-in-warranty': '',
  'extended-warranty': '',
  'maintenance-msg': `Notice: Our website will be undergoing a scheduled maintenance to serve you better. The maintenance is scheduled on Sunday, 9 October 2022, from 9:00am to 3:00pm (GMT +8:00). During this time, our websites will not be accessible.
                      <br><br>
                      We apologize for the inconvenience caused. Thank you for your patience.`,

  'shipping-country-notice-sg': `We are unable to deliver to P.O. boxes and certain restricted areas. <a href="/help/delivery#what-are-the-places-that-you-don-39-t-deliver-to" target="_blank">Learn more</a>.`,
  'shipping-country-notice-au': `We are unable to deliver to P.O. boxes. <a href="/help/delivery#what-are-the-remote-areas" target="_blank">Learn more</a>.`,
  'shipping-country-notice-uk': `This website ships to United Kingdom only, and excludes all overseas territories like Isle of Man and Jersey. We are also unable to deliver to P.O. boxes, Packstations, hotels, motels, and more. <a href="/help/delivery#where-do-you-ship-to" target="_blank">Learn more</a>.`,
  'shipping-country-notice-us': `We are unable to deliver to P.O. boxes, APO, DPO and FPO addresses. <a href="/help/delivery#what-are-the-shipping-methods-available-and-how-do-i-qualify-for-free-shipping" target="_blank">Learn more</a>.`,
  'shipping-country-notice-asean': `We are unable to deliver to P.O. boxes. <a href="/help/delivery#what-are-the-places-that-you-don-39-t-deliver-to" target="_blank">Learn more</a>.`,
  'shipping-country-notice-my': `We are unable to deliver to P.O. boxes. <a href="/help/delivery#what-are-the-places-that-you-don-39-t-deliver-to" target="_blank">Learn more</a>.`,
  'shipping-country-notice-nordic': `This website ships to Denmark, Finland, Norway, and Sweden only, and excludes all overseas territories like Greenland and Faroe Islands. We are also unable to deliver to P.O. boxes, Packstations, hotels, motels, and more. <a href="/help/delivery#where-do-you-ship-to" target="_blank">Learn more</a>.`,
  'shipping-country-notice-gr': `This website ships to Greece only. We are also unable to deliver to P.O. boxes, Packstations, hotels, motels, and more. <a href="/help/delivery#where-do-you-ship-to" target="_blank">Learn more</a>.`,
  'shipping-country-notice-en': `We are unable to deliver to P.O. boxes and these <a href="/help/delivery#what-are-the-overseas-territories-that-you-don-39-t-deliver-to" target="_blank">overseas territories</a>. Please enter an alternative address or <a href="/contactus/otherenquiries" target="_blank" class="alert-link">contact us</a> if you require any assistance.`,
  'shipping-country-notice-ca': `We are unable to deliver to P.O. boxes and these <a href="/help/delivery#what-are-the-overseas-territories-that-you-don-39-t-deliver-to" target="_blank">overseas territories</a>. Please enter an alternative address or <a href="/contactus/otherenquiries" target="_blank" class="alert-link">contact us</a> if you require any assistance.`,
  'shipping-country-notice-hk': `We are unable to deliver to P.O. boxes and these <a href="/help/delivery#what-are-the-overseas-territories-that-you-don-39-t-deliver-to" target="_blank">overseas territories</a>. Please enter an alternative address or <a href="/contactus/otherenquiries" target="_blank" class="alert-link">contact us</a> if you require any assistance.`,

  'acknowledge-return-product-in-original-packaging': 'I acknowledge that the return product(s) is/are in its original packaging, with all accessories included, and in new or as-new condition.'
}
